const flexDirection = {
    name: "flex-direction",
    path: "/flex-direction",
    title: "flex-direction",
    description: "Utilities for controlling the initial size of flex items.",
    value: {
        "flex-direction": {
            "flex-row": "row",
            "flex-row-reverse": "row-reverse",
            "flex-col": "column",
            "flex-col-reverse": "column-reverse",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="flex flex-row ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex flex-row-reverse ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex flex-col ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex flex-col-reverse ...">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex-row</code>
                  to position flex items horizontally in the same direction as text:
            </p>

                <div class="flex flex-row gap-x-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="absolute inset-0 -z-1">
                        <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">01</div>
                    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">02</div>
                    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">03</div>
                </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex-row-reverse</code>
                   to position flex items horizontally in the opposite direction:
            </p>

            <div class="flex flex-row-reverse gap-x-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                <div class="absolute inset-0 -z-1">
                        <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">01</div>
                <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">02</div>
                <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">03</div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex-col</code>
                  to position flex items vertically:
            </p>

            <div class="flex flex-col gap-4 items-center gap-x-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                <div class="absolute inset-0 -z-1">
                        <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                <div class="flex h-14 w-64 items-center justify-center rounded-lg bg-color-violet-500">01</div>
                <div class="flex h-14 w-64 items-center justify-center rounded-lg bg-color-violet-500">02</div>
                <div class="flex h-14 w-64 items-center justify-center rounded-lg bg-color-violet-500">03</div>
            </div>
        
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex-col-reverse</code>
                  to position flex items vertically in the opposite direction:
            </p>

            <div class="flex flex-col-reverse gap-4 items-center gap-x-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                <div class="absolute inset-0 -z-1">
                        <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                    </div>
                <div class="flex h-14 w-64 items-center justify-center rounded-lg bg-color-violet-500">01</div>
                <div class="flex h-14 w-64 items-center justify-center rounded-lg bg-color-violet-500">02</div>
                <div class="flex h-14 w-64 items-center justify-center rounded-lg bg-color-violet-500">03</div>
            </div>
        
            `
        },
    ]
};

export default flexDirection;

<div className="sr-only">

<div class="flex flex-row -z-1 flex-col-reverse flex-row-reverse flex-col gap-x-4 font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">01</div>
                    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">02</div>
                    <div class="flex h-14 w-14 items-center justify-center rounded-lg bg-color-violet-500">03</div>
                </div>

</div>